export default __webpack_public_path__ + "static/media/portfolio.dabfd533.png";